import { TimeRecordStatusNumber } from "../constant/time-record-constants";

export class TimeRecordStatus {
  Id?: number;
  RecordId?: number;
  Number: TimeRecordStatusNumber;
  Name: string;
  IsDeleted: boolean;

  constructor(obj?: Partial<TimeRecordStatus>) {
    if (obj) {
      Object.assign(this, obj);
    } else {
      throw Error('Object cannot be null');
    }
  }

  isSoftDeleted(): boolean {
    return this.IsDeleted;
  }
}
